// Port of webapp/src/blocks/card.ts

import {Block, createBlock} from './block'

export type CardFields = {
    icon?: string
    isTemplate?: boolean
    properties: Record<string, string | string[]>
    contentOrder: Array<string | string[]>
}

export type Card = Block & {
    fields: CardFields
}

export function createCard(block?: Partial<Block>): Card {
    const contentOrder: Array<string | string[]> = []
    const contentIds = (block?.fields?.contentOrder as Array<string | string[]> | undefined)?.filter(
        (id) => id !== null,
    )

    if (contentIds && contentIds.length > 0) {
        for (const contentId of contentIds) {
            if (typeof contentId === 'string') {
                contentOrder.push(contentId)
            } else {
                contentOrder.push(contentId.slice())
            }
        }
    }

    return {
        ...createBlock(block),
        type: 'card',
        fields: {
            icon: block?.fields?.icon || '',
            properties: {...(block?.fields?.properties || {})},
            contentOrder,
            isTemplate: block?.fields?.isTemplate || false,
        },
    }
}
